export default theme => ({
  root: {
    minHeight: '100%',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: theme.colors.primary.white,
    padding: 24,
    boxSizing: 'border-box'
  },
  children: {
    width: '100%',
    maxWidth: 944,
    flex: 1,
    display: 'flex',
    flexFlow: 'column nowrap',
    alignItems: 'center'
  }
});